<template>
	<div v-if="hasEditorAccess" class="landing-page">
		<!-- Header Section -->
		<CustomSection wave style="background: linear-gradient(to left, #fff, #04c51d); margin-top: 0">
			<div class="header-div">
				<v-row class="header-row">
					<v-col cols="12" md="7">
						<div class="header-content">
							<h1 class="headline">ILS Ansbach</h1>
							<p class="header-text">KI-basierte Notrufunterstützung</p>
						</div>
					</v-col>
				</v-row>
			</div>
		</CustomSection>

		<!-- Tab Navigation -->
		<div class="tabs-container">
			<v-tabs v-model="view" class="view-tabs" color="#3c9336" grow>
				<v-tab value="SNA" class="view-tab">
					<v-icon start>mdi-phone-in-talk</v-icon>
					SNA
				</v-tab>
				<v-tab value="Rollenspiel" class="view-tab">
					<v-icon start>mdi-robot</v-icon>
					KI Rollenspiel
				</v-tab>
			</v-tabs>
		</div>

		<!-- SNA -->
		<CustomSection v-show="view === 'SNA'" style="background-color: rgb(var(--v-theme-background))">
			<div class="section-div">
				<div style="width: 100%; height: 100%" class="d-flex justify-center align-center">
					<v-row class="sna-row" justify="center">
						<v-col cols="12" sm="10" md="8" lg="6">
							<div class="textfield-container">
								<v-text-field
									v-model="reference"
									variant="outlined"
									placeholder="Einsatzreferenz eingeben..."
									density="comfortable"
									hide-details
									class="label-field"
									:class="{ 'has-value': !!reference }"
									@keyup.enter="reference && !loading && createAndOpenWorkspace(reference)"
								>
									<template v-slot:append-inner>
										<v-btn
											:color="reference ? '#55D04D' : '#9E9E9E'"
											:disabled="!reference || loading"
											variant="elevated"
											class="create-workspace-btn"
											@click="createAndOpenWorkspace(reference)"
											:loading="loading"
											size="small"
										>
											SNA starten
											<v-icon end>mdi-arrow-right</v-icon>
											<template v-slot:loader>
												<v-progress-circular
													indeterminate
													color="white"
													size="20"
												></v-progress-circular>
											</template>
										</v-btn>
									</template>
								</v-text-field>
							</div>
						</v-col>
					</v-row>
				</div>
			</div>
		</CustomSection>

		<!-- KI ROLLENSPIEL -->
		<CustomSection v-show="view === 'Rollenspiel'" style="background-color: rgb(var(--v-theme-background))">
			<div class="section-div">
				<v-row>
					<!-- <h1 class="title">Wählen Sie einen Fall</h1> -->
					<v-col cols="12">
						<!-- Cases Loading State -->
						<div v-if="loadingCases" class="loading-section">
							<v-progress-circular indeterminate color="#55D04D" size="64"></v-progress-circular>
							<p class="loading-text">Szenarien werden geladen...</p>
						</div>

						<!-- Cases Grid -->
						<v-row v-else-if="cases.length > 0 && hasEditorAccess" class="cases-row" justify="center">
							<v-col
								v-for="(case_, i) in cases"
								:key="case_.botId"
								cols="12"
								sm="8"
								:md="cases.length === 1 ? '6' : '6'"
								:lg="cases.length === 1 ? '6' : cases.length === 2 ? '4' : '4'"
							>
								<v-card class="case-card" elevation="10" variant="tonal">
									<!-- <div class="case-image-wrapper">
										<img class="case-image" :src="getCaseImageURL(i)" alt="Case illustration" />
									</div> -->
									<v-card-title class="case-title">
										<b>{{ case_.botName }}</b>
									</v-card-title>
									<v-card-text class="case-text">
										{{ getCaseDescription(i) }}
									</v-card-text>
									<v-card-actions class="case-actions">
										<v-btn
											color="#55D04D"
											variant="elevated"
											block
											:loading="loading && selectedCaseId === case_.botId"
											class="case-button"
											@click="createAndOpenWorkspace(case_.botName, case_.botId)"
										>
											Rollenspiel starten
											<template v-slot:loader>
												<v-progress-circular
													indeterminate
													size="20"
													color="white"
												></v-progress-circular>
											</template>
										</v-btn>
									</v-card-actions>
								</v-card>
							</v-col>
						</v-row>
						<!-- No Access -->
						<div v-else-if="!hasEditorAccess" class="no-cases-section">
							<v-icon size="64" color="#ff7043" class="mb-4">mdi-lock</v-icon>
							<p class="no-cases-text">Kein Zugang</p>
							<p class="no-cases-text">Sie müssen Editor in dieser Domain sein um Zugriff zu erhalten</p>
						</div>

						<!-- No Cases Available -->
						<div v-else-if="cases.length < 1 && hasEditorAccess" class="no-cases-section">
							<v-icon size="64" color="#55D04D" class="mb-4">mdi-robot-off</v-icon>
							<p class="no-cases-text">Keine Szenarien verfügbar</p>
						</div>
					</v-col>
				</v-row>
			</div>
		</CustomSection>

		<!-- Info Text Section -->
		<!-- <CustomSection style="background-color: rgb(var(--v-theme-background))">
			<div class="section-div">
				<v-row>
					<v-col cols="12">
						<div class="description-section">
							<p class="description-text">
								Wie sieht Berufsberatung aus, wenn Mensch und KI ihre Stärken bündeln? Dieser
								Demonstrator lädt dazu ein, genau das zu erleben. Eine sprachbasierte KI analysiert live
								Gesprächsinhalte, erkennt Werte, Interessen und Einstellungen – und verknüpft sie mit
								über 3.500 Berufseinträgen aus BERUFENET. Das Ergebnis ist eine interaktive, visuell
								unterstützte Beratung, bei der Berufsberater:innen sich auf den versierten Umgang mit
								einer ratsuchenden Person konzentrieren - die KI fokussiert sich hingegen auf die
								Analyse umfangreicher Datenmengen, um sich mit gezielten Hinweisen einzuschalten. Durch
								ein ausgeklügeltes Design der Interaktionen zwischen Mensch und KI bleiben
								Berufsberater:innen jedoch zu jedem Zeitpunkt in der Führungsrolle. Probieren Sie es
								jetzt aus und entdecken Sie das Potenzial symbiotischer Zusammenarbeit zwischen Mensch
								und KI.
							</p>
						</div>
					</v-col>
				</v-row>
			</div>
		</CustomSection> -->

		<!-- Logos Section -->
		<CustomSection style="background-color: rgb(var(--v-theme-background))">
			<div class="section-div">
				<v-row>
					<v-col cols="12">
						<div class="logos-section">
							<div class="logo-container">
								<img :src="LOGO_URL" alt="Logo ILS Ansbach" class="logo" />
							</div>
						</div>
					</v-col>
				</v-row>
			</div>
		</CustomSection>

		<!-- Footer Wave -->
		<CustomSection
			class="last-segment"
			wave
			wave-color="#55D04D"
			style="background-color: rgb(var(--v-theme-background))"
		>
		</CustomSection>

		<Footer />
	</div>
</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted, computed } from "vue";
import { useRouter } from "vue-router";
import { useDomainStore } from "../../../store/domain";
import CustomSection from "../../ansbach/components/CustomSection.vue";
import Footer from "../../ansbach/components/Footer.vue";
import { useInstanceWorkspacesStore } from "../../../store/i-workspace";
import { useInstanceDataspacesStore } from "../../../store/i-dataspace";
import { api as alternisAPI } from "@lr-notitia/notitia-alternis/client";
import { UserRole } from "@lr-notitia/notitia-operator/schemas";

const router = useRouter();
const domainStore = useDomainStore();
const instanceWorkspacesStore = useInstanceWorkspacesStore();
const instanceDataspacesStore = useInstanceDataspacesStore();
const loading = ref(false);

const DOMAIN_ID = "e5073400-a6b4-455f-abdd-f410e729945c"; // ILS Ansbach 🚨
const TEMPLATE_WORKSPACE_ID = "abbf9a80-07de-42d7-a258-38d057a819bb";
const INSTANCE_DATASPACE_ID = "61c4f825-fa17-43ea-97a7-052d9c56b845";
const LOGO_URL = "https://assets.livereader.com/asset/Bensc5QrfkteA8PN.jpg";

const loadingCases = ref(false);
const selectedCaseId = ref<string | null>(null);
const view = ref<"SNA" | "Rollenspiel">("SNA");
const reference = ref("");

const cases = ref<{ botId: string; botName: string }[]>([]);

const hasEditorAccess = computed(() => {
	return domainStore.hasAccessRights(UserRole.Editor) || domainStore.hasAccessRights(UserRole.Admin);
});

function getCaseDescription(i: number): string {
	const descriptions: string[] = [
		"Ein Anrufer hat eine traumatischen Verletzung erlitten und erbittet medizinische Hilfe.",
		"Die Anruferin ruft wegen eines medizinischen Notfalls (kein Trauma) einer dritten Person an und benötigt Unterstützung.",
		"Ein Augenzeuge berichtet von einen Brand in einem Gebäude.",
		"Eine Anruferin berichtet von einem Verkehrsunfall mit potenziellem Gefahrstoffaustritt.",
	];

	return descriptions[i];
}

function getCaseImageURL(i: number): string {
	const images: string[] = [];
	return images[i] || "";
}

async function createAndOpenWorkspace(name: string, botId?: string) {
	if (loading.value || !hasEditorAccess.value) return;

	loading.value = true;
	if (botId) {
		selectedCaseId.value = botId;
	}

	try {
		const timestamp = `Erstellt am ${new Date().toLocaleString("de-DE", { timeZone: "Europe/Berlin" })} von ${
			domainStore.account.firstname
		} ${domainStore.account.lastname}`;

		const workspace = await instanceWorkspacesStore.addWorkspace(
			INSTANCE_DATASPACE_ID,
			TEMPLATE_WORKSPACE_ID,
			name,
			timestamp
		);

		await instanceWorkspacesStore.setWorkspaceDescriptor(
			DOMAIN_ID,
			INSTANCE_DATASPACE_ID,
			workspace.id,
			name,
			timestamp
		);

		const dataspace = instanceDataspacesStore.getById(INSTANCE_DATASPACE_ID);
		if (dataspace) {
			dataspace.workspaces.push(workspace.id);
			await instanceDataspacesStore.updateDataspace(dataspace);
		}

		const url = `/${DOMAIN_ID}/template/${INSTANCE_DATASPACE_ID}/template/${workspace.id}${
			botId ? `?botId=${botId}` : ""
		}`;
		window.open(url, "_blank");
	} catch (error) {
		console.error("Error creating workspace:", error);
	} finally {
		loading.value = false;
		selectedCaseId.value = null;
		reference.value = "";
	}
}

async function loadCases() {
	if (!hasEditorAccess.value) return;

	try {
		loadingCases.value = true;
		const bots = await alternisAPI().bots().get(domainStore.account.id, domainStore.domain.id);
		cases.value = bots.sort((a, b) => a.botName.localeCompare(b.botName));
	} catch (error) {
		console.error("Error loading cases:", error);
	} finally {
		loadingCases.value = false;
	}
}

async function loadData() {
	try {
		await instanceDataspacesStore.loadDataspaces(DOMAIN_ID);
		if (hasEditorAccess.value) {
			await loadCases();
		}
	} catch (error) {
		console.error("Error loading ILS Ansbach data:", error);
		loadingCases.value = false;
	}
}

onMounted(async () => {
	document.body.classList.add("ils-ansbach-page");
	document.body.style.backgroundColor = "rgb(128, 203, 196)";

	loadingCases.value = true;
	try {
		await domainStore.loadDomain(DOMAIN_ID);
		if (!hasEditorAccess.value) {
			throw new Error("No editor access");
		}
		await loadData();
	} catch (error) {
		router.push({ name: "Domains" });
	}
});

onUnmounted(() => {
	document.body.classList.remove("ils-ansbach-page");
	document.body.style.backgroundColor = "";
});
</script>

<style scoped lang="scss">
.landing-page {
	min-height: 100vh;
	min-height: 100dvh;
	display: flex;
	flex-direction: column;
	background-color: #1a1a1a;
}

.header-row {
	margin-top: -30px;
	margin-bottom: -30px;
	@media screen and (max-width: 690px) {
		margin-top: -70px;
		margin-bottom: -50px;
	}
}

.headline {
	font-size: 3rem;
	font-family: "STEPS", sans-serif;
	color: #ffffff;
	text-shadow: 2px 2px 1px rgba(0, 0, 0, 0.5);
	@media screen and (max-width: 690px) {
		font-size: 2rem;
	}
}

.header-text {
	font-size: 1.25rem;
	color: #fff;
	text-shadow: 2px 2px 1px rgba(0, 0, 0, 0.5);
	@media screen and (max-width: 690px) {
		font-size: 1rem;
	}
}

.header-div {
	margin: 100px 3rem 100px;
	@media screen and (max-width: 1200px) {
		margin: 100px 2rem 50px;
	}
	@media screen and (max-width: 690px) {
		margin: 100px 1.75rem 50px;
	}
}

.header-content {
	display: flex;
	height: 100%;
	justify-content: center;
	flex-direction: column;
	text-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);
}

.section-div {
	margin: 60px 3rem 50px;
	@media screen and (max-width: 1200px) {
		margin: 50px 2rem 50px;
	}
	@media screen and (max-width: 690px) {
		margin: 45px 1.75rem 40px;
	}
}

.title {
	color: #55d04d;
	font-size: 3rem;
	text-align: center;
	width: 100%;
	margin-bottom: 2rem;
	text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.5);
	@media screen and (max-width: 1200px) {
		font-size: 2.3rem;
		white-space: normal;
	}
	@media screen and (max-width: 690px) {
		font-size: 2rem;
	}
}

.loading-section {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	min-height: 200px;

	.loading-text {
		color: #55d04d;
		font-size: 1.1rem;
		margin-top: 1rem;
	}
}

.no-cases-section {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	min-height: 200px;

	.no-cases-text {
		color: #55d04d;
		font-size: 1.1rem;
		text-shadow: 0px 0px 1px rgba(0, 0, 0, 0.3);
	}
}

.cases-row {
	margin-bottom: 2rem;
}

.case-card {
	border-radius: 10px;
	padding: 0;
	padding-left: 0.8rem;
	height: 200px;
	transition: transform 0.3s ease, box-shadow 0.3s ease;
	overflow: hidden;
	position: relative;
	display: flex;
	flex-direction: column;

	&::before {
		content: "";
		position: absolute;
		left: 0;
		top: 0;
		bottom: 0;
		width: 0.8rem;
		background-color: #55d04d;
		border-radius: 10px 0 0 10px;
	}

	&[disabled] {
		opacity: 0.7;
		cursor: not-allowed;
	}
}

.case-image-wrapper {
	width: 100%;
	height: 50px;
	overflow: hidden;
	background-color: #55d04d;
	display: flex;
	align-items: center;
	justify-content: center;
}

.case-image {
	width: 100%;
	height: 100%;
	object-fit: cover;
	transition: transform 0.4s ease;
	object-position: 0px -60px;
}

.case-title {
	color: #55d04d;
	font-size: 1.3rem;
	padding: 1.25rem 1rem 0.75rem 1rem;
	@media screen and (max-width: 690px) {
		line-height: 80%;
		font-size: 1.1rem;
		max-width: 100%;
		white-space: pre-wrap;
		word-break: break-word;
	}
}

.case-text {
	font-size: 1rem;
	line-height: 1.5;
	padding: 0 1rem 1rem 1rem;
	flex-grow: 1;
}

.case-icon-wrapper {
	display: flex;
	justify-content: center;
	margin-bottom: 1rem;
}

.case-actions {
	padding: 0 1rem 1rem 1rem;
	margin-top: auto;
}

.case-button {
	font-weight: 600;
	transition: box-shadow 0.2s cubic-bezier(0.4, 0, 0.2, 1), background-color 0.2s cubic-bezier(0.4, 0, 0.2, 1);
	letter-spacing: 0.5px;
	box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);

	&:hover:not([disabled]) {
		background-color: #115d89 !important;
		box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12);
	}

	&:active:not([disabled]) {
		background-color: #114666 !important;
		box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.2), 0 8px 10px 1px rgba(0, 0, 0, 0.14),
			0 3px 14px 2px rgba(0, 0, 0, 0.12);
	}
}

.description-section {
	margin: 2rem 0;
	text-align: center;

	.description-text {
		color: #55d04d;
		font-size: 1.1rem;
		line-height: 1.6;
		text-shadow: 0px 0px 1px rgba(0, 0, 0, 0.3);
		max-width: 1000px;
		margin: 0 auto;
		text-align: justify;

		@media screen and (max-width: 690px) {
			font-size: 1rem;
			text-align: left;
		}
	}
}

.logos-section {
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 4rem;
	margin: 2rem 0;

	@media screen and (max-width: 768px) {
		flex-direction: column;
		gap: 2rem;
	}

	.logo-container {
		display: flex;
		align-items: center;
		justify-content: center;
		background-color: white;
		border-radius: 10px;
		padding: 15px;
		width: 250px;
		height: 120px;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

		@media screen and (max-width: 690px) {
			width: 200px;
			height: 100px;
			padding: 10px;
		}

		.logo {
			height: auto;
			transition: filter 0.3s ease;
			max-width: 200px;
			max-height: 80px;

			@media screen and (max-width: 690px) {
				max-width: 160px;
				max-height: 70px;
			}
		}
	}
}

@media (max-width: 768px) {
	.header-div {
		margin: 50px 1rem 50px;
	}

	.section-div {
		margin: 30px 1rem 30px;
	}
}

.nonSelect {
	-webkit-touch-callout: none;
	-webkit-user-select: none;
	-khtml-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none;
}

svg {
	.affected_person_tag_fill {
		fill: #f4f4f4;
	}

	&.dark {
		.affected_person_tag_fill {
			fill: #404040;
		}
	}
}

.last-segment {
	padding-top: 80px;
	background-color: #a9a9a9;
}

.tab-title {
	color: #55d04d;
}

.tabs-container {
	background-color: rgb(var(--v-theme-background));
	padding: 0 1rem;
	padding-top: 1.5rem;

	.view-tabs {
		max-width: 800px;
		margin: 20px auto 0 auto;
		border-radius: 12px;
		overflow: hidden;
		background: rgba(0, 107, 143, 0.08);

		.view-tab {
			font-weight: 600;
			letter-spacing: 0.5px;
			text-transform: none;
			font-size: 1rem;
			min-height: 48px;

			@media screen and (max-width: 690px) {
				font-size: 0.875rem;
			}
		}
	}
}

.sna-row {
	width: 100%;
	margin: 0;
}

.textfield-container {
	width: 100%;
	display: flex;
	align-items: stretch;

	.label-field {
		flex: 1;

		:deep(.v-field) {
			transition: box-shadow 0.2s ease, border-color 0.2s ease;
			padding-right: 6px;
			border-radius: 8px;
		}

		:deep(.v-field__outline) {
			--v-field-border-opacity: 0.25;
		}

		:deep(.v-field--focused .v-field__outline) {
			--v-field-border-opacity: 0.25;
		}

		:deep(.v-field--focused) {
			box-shadow: 0 0 0 3px rgba(85, 208, 77, 0.3);
		}

		&.has-value {
			:deep(.v-field__outline) {
				--v-field-border-opacity: 1;
				color: #55d04d;
			}
		}

		:deep(.v-field__append-inner) {
			align-items: center;
			padding-top: 0;
		}
	}

	.create-workspace-btn {
		min-width: auto;
		height: 36px;
		box-shadow: none;
		color: white;
		transition: all 0.25s ease;
		border-radius: 6px;
		font-weight: 600;
		letter-spacing: 0.3px;

		&:not(:disabled) {
			box-shadow: 0 2px 4px rgba(85, 208, 77, 0.3);
		}

		&:disabled {
			opacity: 0.6;
		}
	}
}
</style>
